export default __webpack_public_path__ + "static/media/025-turn-left-1.1f0b2b04.png";